import { useDispatch } from 'store/hooks';
import { loadLayoutActionAsync, switchLayoutAsync } from './thunks';
import {
    layoutClearPendingLayoutAction,
    layoutSetPanelIdAction,
    resetLayoutAction,
    setLayoutManualSave,
} from './actions';
import { useCallback } from 'react';

/*
 * Used for the initial layout load
 */
export const useDispatchLoadLayoutAction = () => {
    const dispatch = useDispatch();
    return (origin: string, layoutName: string) => {
        dispatch(loadLayoutActionAsync(origin, layoutName));
    };
};

/*
 * Switches the layout i.e. load the layout and updates the panel id if in a Newport palette
 */
export const useDispatchSwitchLayoutAction = () => {
    const dispatch = useDispatch();
    return (origin: string, layoutName: string) => {
        dispatch(switchLayoutAsync(origin, layoutName));
    };
};

export const useDispatchSetLayoutPanelId = () => {
    const dispatch = useDispatch();
    return (panelId: string) => {
        dispatch(layoutSetPanelIdAction(panelId));
    };
};

export const useDispatchClearPendingLayout = () => {
    const dispatch = useDispatch();
    return useCallback(() => {
        dispatch(layoutClearPendingLayoutAction());
    }, [dispatch]);
};

export const useDispatchSetManualLayoutSave = () => {
    const dispatch = useDispatch();
    return (manualSave: boolean) => {
        dispatch(setLayoutManualSave(manualSave));
    };
};

export const useDispatchResetLayout = () => {
    const dispatch = useDispatch();
    return () => {
        dispatch(resetLayoutAction());
    };
};
